import { createContext, type ReactNode, useContext } from 'react';
import { useAuth } from '../auth/auth-context.js';
import type { AuftragsQuelle } from './runs-source.js';
import { type AuftragsZustand, useWartende } from './use-runs.js';

/**
 * Auch die Wartenden-Abfrage bekommt eine Grenze -- grosszuegig, aber vorhanden. Die
 * Begruendung "wartende Laeufe sammeln sich fachlich nicht an" ist eine Annahme ueber das
 * Verhalten von Menschen, keine erzwungene Regel: Wird nie entschieden, wachsen sie sehr
 * wohl. Ein unbegrenzter Echtzeit-Listener waere dann ein unbegrenzter Initial-Read.
 * Greift die Grenze, sagt es die Oberflaeche.
 */
export const WARTENDE_GRENZE = 500;

const WartendeKontext = createContext<AuftragsZustand | null>(null);

/**
 * EIN Listener fuer alle, die wartende Laeufe brauchen: die Auftragsliste und der Zaehler
 * in der Seitenleiste. Er haengt ueber der Shell, weil die Shell als Layout-Route beim
 * Seitenwechsel gemountet bleibt -- frueher lebte er in der Liste und wurde bei jedem
 * Wechsel ab- und wieder aufgebaut (Spec A, Abschnitt 4).
 */
export function WartendeProvider({
  quelle,
  children,
}: {
  quelle: AuftragsQuelle;
  children: ReactNode;
}) {
  const { nutzer } = useAuth();
  const zustand = useWartende(quelle, WARTENDE_GRENZE, nutzer?.uid ?? null);
  return <WartendeKontext.Provider value={zustand}>{children}</WartendeKontext.Provider>;
}

export function useWartendeKontext(): AuftragsZustand {
  const wert = useContext(WartendeKontext);
  if (!wert) {
    throw new Error('useWartendeKontext braucht einen WartendeProvider oberhalb im Baum.');
  }
  return wert;
}
